import axios from 'axios'
import router from '@/router'
import Vue from 'vue'
import { Toast } from 'vant'
import { REQUEST_BASICS } from './request.config'
Vue.use(Toast)
const instance = axios.create({
    ...REQUEST_BASICS,
});
// 请求拦截，在请求头中加token
instance.interceptors.request.use(
    config => {
        // 判断是否存在token，如果存在的话，则每个http header都加上token
        let token = localStorage.getItem('token')
        if (!config.headers.hasOwnProperty('Authorization') && token) {
            config.headers.Authorization = "bearer " + token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    });
// 添加响应拦截器
instance.interceptors.response.use(function(response) {
    return response;

}, function(error) {
    // 对响应错误做点什么
    // if (error.response.status == 403) {
    //     Toast.fail(error.response.data.error.message);
    // } else if (error.response.status == 401) {
    //     Toast.fail('未授权，请重新登录');
    // } else if (error.response.status == 404) {
    //     Toast.fail('请求错误,未找到该资源');
    // } else if (error.response.status == 500) {
    //     Toast.fail('服务器端出错');
    // } else if (error.response.status == 408) {
    //     Toast.fail('请求超时');
    // } else {
    //     Toast.fail('请求失败');
    // }
    return Promise.reject(error);
});

export default instance;